import React, { useMemo, useState } from "react";

function normalizeChecked(checked, defaultChecked) {
  if (typeof checked === "boolean") {
    return checked;
  }

  return Boolean(defaultChecked);
}

export function UserDeclaration({
  checked,
  defaultChecked = false,
  onAccept,
  onCheckedChange,
  className = ""
}) {
  const resolvedChecked = normalizeChecked(checked, defaultChecked);
  const [isExpanded, setIsExpanded] = useState(false);
  const wrapperClassName = useMemo(
    () => ["echoUserDeclaration", className].filter(Boolean).join(" "),
    [className]
  );

  return (
    <div className={wrapperClassName}>
      <div className="echoUserDeclaration__summary">
        <div className="echoUserDeclaration__summaryText">
          <h3 className="echoUserDeclaration__title">User Content &amp; Copyright Declaration</h3>
          <p className="echoUserDeclaration__intro">
            By uploading content, you confirm you have the rights to use it and agree to PageTone&apos;s
            copyright declaration.
          </p>
        </div>

        <button
          className="echoUserDeclaration__toggle"
          type="button"
          aria-expanded={isExpanded}
          onClick={() => setIsExpanded((currentValue) => !currentValue)}
        >
          {isExpanded ? "Hide details" : "View details"}
        </button>
      </div>

      {isExpanded ? (
        <div className="echoUserDeclaration__details">
          <ol className="echoUserDeclaration__list">
            <li>
              <strong>You own or have obtained the necessary rights</strong> to any
              text, lyrics, or audio files you upload.
            </li>
            <li>
              <strong>You are solely responsible</strong> for ensuring your use of
              this platform does not infringe any third-party copyright, moral
              rights, or other intellectual property rights.
            </li>
            <li>
              <strong>This platform does not store your uploaded files or generated outputs.</strong>
              {" "}All processing is temporary; results are downloaded directly to your
              device and immediately deleted from our servers.
            </li>
            <li>
              <strong>This service is provided for personal, non-commercial use only</strong>,
              {" "}unless you have separately obtained a commercial licence for the
              content you upload.
            </li>
            <li>
              You agree to indemnify and hold harmless{" "}
              <strong>Roots &amp; Bridge Publishing Inc.</strong> from any claims
              arising from your use of third-party content.
            </li>
          </ol>
        </div>
      ) : null}

      <label className="echoUserDeclaration__checkLabel">
        <input
          className="echoUserDeclaration__checkbox"
          type="checkbox"
          checked={resolvedChecked}
          onChange={(event) => {
            const nextChecked = event.target.checked;
            onCheckedChange?.(nextChecked);
            if (nextChecked) {
              onAccept?.();
            }
          }}
        />
        <span>I have read and agree to the above declaration.</span>
      </label>
    </div>
  );
}

export function UserDeclarationFull() {
  return (
    <section className="echoUserDeclaration echoUserDeclaration--full">
      <h2 className="echoUserDeclaration__title">User Content &amp; Copyright Policy</h2>
      <p className="echoUserDeclaration__intro">
        Roots &amp; Bridge Publishing Inc. | RB Studio
      </p>
      <ol className="echoUserDeclaration__list">
        <li>
          You are responsible for ensuring you have the right to upload, process,
          translate, or export any content used with this service.
        </li>
        <li>
          This platform processes files temporarily and does not archive uploaded
          files or generated outputs on our servers.
        </li>
        <li>
          Use of third-party content for public, commercial, or licensed
          distribution remains your responsibility.
        </li>
      </ol>
    </section>
  );
}

export default UserDeclaration;
